import yup from './default';

export const signInValidationSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().min(6).required(),
  rememberMe: yup.bool().required(),
});
